function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}


const update = (
entity,
data) =>



{
  const updatedEntity = _objectSpread({}, entity);

  if (!data) return entity;

  const { title, properties } = data;

  if (title) {
    updatedEntity.title = title;
  }

  if (properties !== null && properties !== void 0 && properties.length) {
    properties.forEach((property) => {var _updatedEntity$metada;
      const [propertyName] = Object.keys(property);

      const hasProperty = updatedEntity.metadata ? (_updatedEntity$metada =
      updatedEntity.metadata[propertyName]) === null || _updatedEntity$metada === void 0 ? void 0 : _updatedEntity$metada.length :
      false;

      if (hasProperty) {
        if (property[propertyName]) {
          updatedEntity.metadata[propertyName][0].value = property[propertyName];
        }

        if (!property[propertyName]) {
          delete updatedEntity.metadata[propertyName];
        }
      }

      if (!hasProperty && property[propertyName]) {var _propertyName;
        updatedEntity.metadata[propertyName] = [];
        (_propertyName = updatedEntity.metadata[propertyName]) === null || _propertyName === void 0 ? void 0 : _propertyName.push({ value: property[propertyName] });
      }
    });
  }

  return updatedEntity;
};

export { update };